import { Component, Input, inject } from '@angular/core';
import { BookingFormComponent } from '../booking-form/booking-form';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogService } from '../../../../services/dialog.service';
import { GlassPillDirective } from '../../../directives/glass-pill.directive';
import { HapticsService } from '../../../services/haptics.service';
import { BookingChatComponent } from '../booking-chat/booking-chat.component';
import { GtmService } from '../../../../../core/services/gtm.service';

@Component({
  selector: 'app-booking-request-button',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    BookingFormComponent,
    GlassPillDirective
  ],
  standalone: true,
  templateUrl: './booking-request-button.html',
  styleUrl: './booking-request-button.scss',
})
export class BookingRequestButtonComponent {
  private dialogService = inject(DialogService);
  private gtm = inject(GtmService);
  private haptics = inject(HapticsService);

  @Input() propertyId: string | null = null;

  openBookingRequest() {
    this.haptics.click();
    this.gtm.bookingRequest(this.propertyId ?? '');
    const ref = this.dialogService.open(BookingChatComponent, {
      width: '450px',
      maxWidth: '90vw',
      height: '650px',
      panelClass: 'chat-dialog-container', // Custom class for styling
      data: { propertyId: this.propertyId }
    });

    // const ref = this.dialogService.open(BookingFormComponent, {
    //   data: { propertyId: this.propertyId },
    //   panelClass: ['app-dialog-panel', 'booking-dialog']
    // });

    ref.afterClosed().subscribe(result => {
      if (result) {
        console.log('booking result', result);
      }
    });
  }
}
